import script from "./SortItems.vue?vue&type=script&setup=true&lang=ts"
export * from "./SortItems.vue?vue&type=script&setup=true&lang=ts"

import "./SortItems.vue?vue&type=style&index=0&id=c8a3b2ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8a3b2ca"]])

export default __exports__